import { clamp, overlap, tone, label } from './shared';

export class Shooter {
  constructor(random, finish) {
    this.random = random; this.finish = finish; this.score = 0; this.level = 0; this.lives = 3;
    this.time = 0; this.player = { x: 300, y: 637 }; this.shield = 0; this.double = 0; this.invincible = 2;
    this.bullets = []; this.shots = []; this.enemies = []; this.pickups = []; this.particles = []; this.popups = [];
    this.cooldown = 0; this.transition = 2; this.banner = 'READY, PILOT'; this.bannerTime = 0; this.over = false; this.kills = 0;
    this.stars = Array.from({ length: 65 }, (_, i) => ({ x: (i * 137) % 600, y: (i * 97) % 700, speed: 20 + i % 40 }));
  }
  wave() {
    this.level++; this.shots = []; this.bullets = []; this.invincible = Math.max(this.invincible, 1.5);
    this.boss = this.level % 5 === 0; this.bonus = !this.boss && this.level % 4 === 0; this.waveTime = 0; this.waveKills = 0;
    this.banner = this.boss ? 'WARNING: FLAGSHIP' : this.bonus ? 'BONUS FLIGHT — NO ENEMY FIRE' : `WAVE ${this.level}`;
    this.bannerTime = 2.2; tone('wave');
    if (this.boss) {
      this.enemies = [{ x: 235, y: -110, w: 130, h: 80, homeX: 235, homeY: 100, hp: 35 + this.level * 3, maxHp: 35 + this.level * 3, type: 3, phase: 0, dive: 0, points: 1500, entry: 0 }];
    } else {
      const count = this.bonus ? 20 : 24 + Math.min(12, Math.floor(this.level / 2) * 6);
      this.enemies = Array.from({ length: count }, (_, i) => ({
        x: i % 2 ? -60 : 660, y: -80 - i * 20, w: 32, h: 28,
        homeX: 77 + (i % 6) * 78, homeY: 92 + Math.floor(i / 6) * 46,
        hp: i < 6 && this.level > 2 ? 2 : 1, type: i < 6 ? 0 : i < 12 ? 1 : 2,
        phase: this.random() * Math.PI * 2, dive: 0, points: i < 6 ? 80 : 40, entry: i * .065,
      }));
    }
    this.attackTimer = 2.8; this.fireTimer = 1.4; this.totalInWave = this.enemies.length;
  }
  burst(x, y, color, count = 14) {
    for (let i = 0; i < count; i++) { const a = i / count * Math.PI * 2; this.particles.push({ x, y, vx: Math.cos(a) * (65 + i * 5), vy: Math.sin(a) * (65 + i * 5), life: .5, color }); }
  }
  damage() {
    if (this.invincible > 0 || this.over) return;
    if (this.shield > 0) this.shield = 0; else this.lives--;
    this.invincible = 2; this.shots = []; this.burst(this.player.x, this.player.y, '#ff6b89', 24); tone('hurt');
    if (this.lives <= 0) { this.over = true; this.finish({ score: this.score, level: this.level, detail: `${this.kills} enemies down`, achievement: this.level >= 5 ? 'Flagship encounter' : this.score >= 1000 ? 'Ace in training' : 'First flight' }); }
  }
  update(dt, input) {
    if (this.over) return;
    this.time += dt; this.invincible -= dt; this.double = Math.max(0, this.double - dt); this.bannerTime -= dt;
    this.stars.forEach(s => { s.y = (s.y + s.speed * dt) % 700; });
    this.particles.forEach(p => { p.x += p.vx * dt; p.y += p.vy * dt; p.life -= dt; }); this.particles = this.particles.filter(p => p.life > 0);
    this.popups.forEach(p => { p.y -= dt * 30; p.life -= dt; }); this.popups = this.popups.filter(p => p.life > 0);
    if (input.targetX != null) this.player.x += clamp(input.targetX - this.player.x, -480 * dt, 480 * dt);
    else this.player.x += ((input.right ? 1 : 0) - (input.left ? 1 : 0)) * 360 * dt;
    this.player.x = clamp(this.player.x, 22, 578);
    this.pickups.forEach(p => {
      p.y += 110 * dt;
      if (overlap(p, { x: this.player.x - 22, y: this.player.y - 22, w: 44, h: 44 })) {
        if (p.type === 'shield') this.shield = 1; else this.double = 12;
        p.y = 800; tone('collect'); this.popups.push({ x: this.player.x, y: this.player.y - 30, text: p.type === 'shield' ? 'SHIELD' : 'DOUBLE SHOT', life: 1.2 });
      }
    }); this.pickups = this.pickups.filter(p => p.y < 720);
    if (this.transition > 0) { this.transition -= dt; if (this.transition <= 0) this.wave(); return; }
    this.waveTime += dt; this.cooldown -= dt;
    if ((input.shoot || input.pointer) && this.cooldown <= 0) {
      for (const offset of this.double > 0 ? [-12, 12] : [0]) this.bullets.push({ x: this.player.x + offset - 2, y: this.player.y - 22, w: 4, h: 15 });
      this.cooldown = .16; tone('shot');
    }
    this.bullets.forEach(b => b.y -= 540 * dt); this.bullets = this.bullets.filter(b => b.y > -20 && !b.dead);
    this.shots.forEach(b => { b.y += b.vy * dt; b.x += b.vx * dt; }); this.shots = this.shots.filter(b => b.y < 730 && b.x > -20 && b.x < 620);
    this.attackTimer -= dt; this.fireTimer -= dt;
    if (!this.boss && this.waveTime > 3 && this.attackTimer <= 0) {
      const ready = this.enemies.filter(e => !e.dive && !e.dead);
      if (ready.length) { const e = ready[Math.floor(this.random() * ready.length)]; e.dive = .01; e.diveX = e.x; }
      this.attackTimer = this.bonus ? .25 : Math.max(.65, 2 - this.level * .12);
    }
    if (!this.bonus && this.waveTime > 2 && this.fireTimer <= 0 && this.enemies.length) {
      const e = this.enemies[Math.floor(this.random() * this.enemies.length)];
      const speed = Math.min(320, 170 + this.level * 12);
      const aim = clamp((this.player.x - e.x - e.w / 2) * .5, -100, 100);
      for (const spread of this.boss ? [-90, -45, 0, 45, 90] : [0]) this.shots.push({ x: e.x + e.w / 2, y: e.y + e.h, w: 7, h: 14, vx: aim + spread, vy: speed });
      this.fireTimer = Math.max(.24, .95 - this.level * .045);
    }
    for (const e of this.enemies) {
      if (this.waveTime < e.entry) continue;
      if (e.dive) {
        e.dive += dt; e.y += (this.bonus ? 240 : 195 + this.level * 7) * dt; e.x = e.diveX + Math.sin(e.dive * 3) * 95;
        if (e.y > 730) { if (this.bonus) e.dead = true; else { e.dive = 0; e.y = -60; } }
      } else {
        const target = e.homeX + Math.sin(this.waveTime * (this.boss ? 1 : .7)) * (this.boss ? 160 : 35);
        e.x += (target - e.x) * Math.min(1, dt * 3); e.y += (e.homeY - e.y) * Math.min(1, dt * 3);
      }
      for (const b of this.bullets) {
        if (!b.dead && !e.dead && overlap(b, e)) {
          b.dead = true; e.hp--; e.flash = .09;
          if (e.hp <= 0) {
            e.dead = true; this.kills++; this.waveKills++; this.score += e.points;
            this.burst(e.x + e.w / 2, e.y + e.h / 2, ['#ff5fa2', '#69deff', '#ffe27a', '#b89aff'][e.type], this.boss ? 40 : 14);
            this.popups.push({ x: e.x, y: e.y, text: `+${e.points}`, life: .7 }); tone('hit');
            if (this.kills % 9 === 0 || this.boss) this.pickups.push({ x: e.x, y: e.y, w: 25, h: 25, type: this.kills % 18 === 0 ? 'shield' : 'double' });
          }
        }
      }
      e.flash = Math.max(0, (e.flash || 0) - dt);
      if (!e.dead && overlap({ x: this.player.x - 12, y: this.player.y - 12, w: 24, h: 24 }, e)) this.damage();
      if (this.over) return;
    }
    this.enemies = this.enemies.filter(e => !e.dead);
    const playerBox = { x: this.player.x - 11, y: this.player.y - 11, w: 22, h: 24 };
    for (const b of this.shots) if (overlap(b, playerBox)) { this.damage(); break; }
    if (this.over) return;

    if (!this.enemies.length && !this.over) {
      const bonus = this.bonus ? this.waveKills * 100 : 200;
      this.score += bonus; this.transition = 2.4; this.shots = []; this.banner = this.bonus ? `BONUS: ${this.waveKills}/${this.totalInWave} • +${bonus}` : `WAVE CLEAR • +${bonus}`;
      tone('collect');
    }
  }
  draw(ctx, reduced) {
    ctx.fillStyle = '#080d23'; ctx.fillRect(0, 0, 600, 700);
    for (const s of this.stars) { ctx.fillStyle = s.speed > 45 ? '#8aa6ce' : '#334564'; ctx.fillRect(s.x, reduced ? (s.speed * 97) % 700 : s.y, 2, 2); }
    ctx.fillStyle = '#111c36'; ctx.fillRect(0, 0, 600, 51);
    label(ctx, String(this.score).padStart(6, '0'), 20, 33, 23); label(ctx, `WAVE ${this.level || 1}`, 300, 32, 17, '#a8b9dd', 'center');
    label(ctx, `${'♥ '.repeat(Math.max(0, this.lives))}`, 582, 33, 22, '#ff789e', 'right');
    for (const e of this.enemies) {
      const x = e.x + e.w / 2, y = e.y + e.h / 2;
      ctx.save(); ctx.translate(x, y); if (e.dive) ctx.rotate(Math.sin(e.dive * 3) * .4);
      ctx.fillStyle = e.flash ? '#fff' : ['#ff5fa2', '#69deff', '#ffe27a', '#b89aff'][e.type];
      if (e.type === 3) {
        ctx.beginPath(); ctx.moveTo(-65, 18); ctx.lineTo(-48, -25); ctx.lineTo(-20, -10); ctx.lineTo(0, -40); ctx.lineTo(20, -10); ctx.lineTo(48, -25); ctx.lineTo(65, 18); ctx.lineTo(0, 40); ctx.closePath(); ctx.fill();
        ctx.fillStyle = '#ff4e7c'; ctx.fillRect(-28, -3, 56, 9);
      } else {
        ctx.beginPath(); ctx.ellipse(0, 0, e.type === 1 ? 9 : 15, 12, 0, 0, Math.PI * 2); ctx.fill();
        if (e.type === 1) { ctx.fillRect(-22, -10, 12, 18); ctx.fillRect(10, -10, 12, 18); }
        if (e.type === 0) { ctx.fillRect(-11, -18, 5, 10); ctx.fillRect(6, -18, 5, 10); }
        ctx.fillStyle = '#080d23'; ctx.fillRect(-8, -4, 5, 5); ctx.fillRect(3, -4, 5, 5);
      }
      ctx.restore();
      if (e.type === 3) { ctx.fillStyle = '#253153'; ctx.fillRect(160, 58, 280, 6); ctx.fillStyle = '#b89aff'; ctx.fillRect(160, 58, 280 * e.hp / e.maxHp, 6); }
    }
    ctx.fillStyle = '#8dffd9'; for (const b of this.bullets) if (!b.dead) ctx.fillRect(b.x, b.y, b.w, b.h);
    ctx.fillStyle = '#ff708c'; for (const b of this.shots) ctx.fillRect(b.x, b.y, b.w, b.h);
    for (const p of this.pickups) { ctx.fillStyle = p.type === 'shield' ? '#68dfff' : '#a0ffa5'; ctx.fillRect(p.x, p.y, 25, 25); label(ctx, p.type === 'shield' ? 'S' : 'D', p.x + 12, p.y + 19, 18, '#080d23', 'center'); }
    if (this.invincible <= 0 || Math.floor(this.time * 10) % 2 || reduced) {
      ctx.save(); ctx.translate(this.player.x, this.player.y);
      ctx.fillStyle = '#f8b45b'; ctx.fillRect(-5, 15, 10, 12 + Math.sin(this.time * 40) * 5);
      ctx.fillStyle = '#b6d9ff'; ctx.beginPath(); ctx.moveTo(0, -25); ctx.lineTo(23, 20); ctx.lineTo(0, 11); ctx.lineTo(-23, 20); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#3e8bc9'; ctx.fillRect(-4, -8, 8, 18);
      if (this.shield || this.invincible > 0) { ctx.strokeStyle = '#69deff'; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(0, 0, 30, 0, Math.PI * 2); ctx.stroke(); }
      ctx.restore();
    }
    if (!reduced) for (const p of this.particles) { ctx.globalAlpha = Math.max(0, p.life * 2); ctx.fillStyle = p.color; ctx.fillRect(p.x, p.y, 4, 4); } ctx.globalAlpha = 1;
    for (const p of this.popups) label(ctx, p.text, clamp(p.x, 80, 500), p.y, 16, '#a0ffcf', 'center');
    if (this.transition > 0 || this.bannerTime > 0) { ctx.fillStyle = '#080d23dd'; ctx.fillRect(15, 310, 570, 66); label(ctx, this.banner, 300, 350, 21, '#e2eaff', 'center'); }
    if (this.double > 0) label(ctx, `DOUBLE SHOT ${Math.ceil(this.double)}s`, 20, 688, 15, '#a0ffa5');
    if (this.shield) label(ctx, 'SHIELD READY', 580, 688, 15, '#69deff', 'right');
  }
}
